module.exports = __webpack_public_path__ + "static/AatchiTamizhLogo-ed31ff55899db1d6c6f96c9750815ebc.png";